;(function () {
  'use strict'

  angular
    .module('contrast.survey')
    .controller('SurveyCtrl', ['SurveyService', SurveyCtrl])

  function SurveyCtrl(SurveyService) {
    function init() {
      SurveyService.open()
    }

    init()
  }
})()
